import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { getNewTicketCountFetch } from "store/middlewares/tickets.crud"

const useTicketCount = () => {

    return useQuery({
        queryKey: [qc.newTicketCount],
        queryFn: async () => {
            const { data } = await getNewTicketCountFetch()
            return data
        },
        refetchOnMount: true,
    })
}

export default { useTicketCount }